var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('BeatLoader',{attrs:{"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }